const ArrowRight = ({ width = 24, height = 24, className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    data-name="Layer 1"
    viewBox="0 0 512 512"
    className={className}
    {...props}
  >
    <path d="M121.373 457.373 322.745 256 121.373 54.627a32 32 0 0 1 45.254-45.254l224 224a32 32 0 0 1 0 45.254l-224 224a32 32 0 0 1-45.254-45.254z" />
  </svg>
);
export default ArrowRight;
